module.exports = __webpack_public_path__ + "static/media/IMG-11.15e160fe.jpg";